import plantDataConfigApi from '@/api/config/plantDataConfigApi'
import { queryKeys } from '@/constant/common'
import { CreatePlant } from '@/types/plant'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function create(payload: CreatePlant): Promise<void> {
  await plantDataConfigApi.create(payload)
}

function useAddPlant() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: CreatePlant) => create(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.plant])
      toast.success(t('addPlantSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 404) {
        toast.error(error?.message)
      } else toast.error(t('addPlantError'))
    },
  })

  // return mutate
}

export default useAddPlant
